import { render, staticRenderFns } from "./ChatDemo.vue?vue&type=template&id=f30979f6"
import script from "./ChatDemo.vue?vue&type=script&lang=js"
export * from "./ChatDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports